// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.ProductDetail_details-container__O151i {
  display: flex;
  gap: 24px;
}
.ProductDetail_details-container__O151i .ProductDetail_images-container__eSfRJ {
  width: 33%;
  display: flex;
}
.ProductDetail_details-container__O151i .ProductDetail_images-container__eSfRJ .ProductDetail_carousel-container__heqU8 {
  width: 100%;
}
.ProductDetail_details-container__O151i .ProductDetail_properties-container__SYB1P {
  width: 33%;
}
.ProductDetail_details-container__O151i .ProductDetail_summary-container__j-YUk {
  width: 33%;
}
.ProductDetail_details-container__O151i .ProductDetail_summary-container__j-YUk .ProductDetail_price-container__FgfXw {
  margin-bottom: 30px;
}

@media (min-width: 1360px) {
  .ProductDetail_carousel-container__heqU8 {
    min-height: 550px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/ProductDetail.module.scss"],"names":[],"mappings":"AAEA;;;EAGE,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;AAEE;EACE,UAAA;EACA,aAAA;AAAJ;AACI;EACE,WAAA;AACN;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,UAAA;AAAJ;AACI;EACE,mBAAA;AACN;;AAIA;EACE;IACE,iBAAA;EADF;AACF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n.details-container {\n  display: flex;\n  gap: 24px;\n  .images-container {\n    width: 33%;\n    display: flex;\n    .carousel-container {\n      width: 100%;\n    }\n  }\n  .properties-container {\n    width: 33%;\n  }\n  .summary-container {\n    width: 33%;\n    .price-container {\n      margin-bottom: 30px;\n    }\n  }\n}\n\n@media (min-width: 1360px) {\n  .carousel-container {\n    min-height: 550px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details-container": `ProductDetail_details-container__O151i`,
	"images-container": `ProductDetail_images-container__eSfRJ`,
	"carousel-container": `ProductDetail_carousel-container__heqU8`,
	"properties-container": `ProductDetail_properties-container__SYB1P`,
	"summary-container": `ProductDetail_summary-container__j-YUk`,
	"price-container": `ProductDetail_price-container__FgfXw`
};
export default ___CSS_LOADER_EXPORT___;
